module.exports = __webpack_public_path__ + "static/media/color_logo_transparent_extreme_readER_demo_100.3e650773.png";